/* MY STORE · Armá tu look: sugiere una prenda de arriba + una de abajo con criterio de estilista
   (mismas reglas que "Combinalo con..": colores, estilo, temporada, estampas), deja cambiar cada una
   a mano desde una lista ordenada por combinación y sumar prendas extra (calzado, otra remera, etc.). */
(function () {
  'use strict';
  var DIC = 'AZUL MARINO:marino|AZUL OSCURO:marino|OFF WHITE:crema|LIGHT BLUE:celeste|ICE BLUE:celeste|BABY BLUE:celeste|GREEN LIGHT:verde|VERDE CLARO:verde|NEGRO:negro|NEGRA:negro|BLACK:negro|BLAKC:negro|PRETO:negro|PRETA:negro|BLANCO:blanco|BLANCA:blanco|WHITE:blanco|BRANCO:blanco|BCO:blanco|MARFIL:crema|CREMA:crema|CREAMY:crema|CREAM:crema|CRUDO:crema|NATURAL:crema|HUESO:crema|BEIGE:beige|ARENA:beige|CAMEL:beige|CARAMELO:beige|TAN:beige|KAKI:beige|KAKHY:beige|KHAKI:beige|MARRON:marron|MARROM:marron|BROWN:marron|CHOCOLATE:marron|COGNAC:marron|CAFE:marron|TOSTADO:marron|GRIS:gris|GRAY:gris|GREY:gris|CINZA:gris|PLOMO:gris|MELANGE:gris|MARINO:marino|NAVY:marino|MARINHO:marino|AZUL:azul|BLUE:azul|FRANCIA:azul|ROYAL:azul|INDIGO:azul|CELESTE:celeste|SKY:celeste|VERDE:verde|GREEN:verde|PETROLEUM:verde|PETROLEO:verde|MOSS:verde|MUSGO:verde|OLIVA:verde|OLIVE:verde|MILITAR:verde|MOSTAZA:mostaza|MUSTARD:mostaza|OCRE:mostaza|AMARILLO:amarillo|YELLOW:amarillo|ROJO:rojo|ROJA:rojo|RED:rojo|BORDO:bordo|WINE:bordo|VINO:bordo|BURGUNDY:bordo|ROSA:rosa|PINK:rosa|PEACH:rosa|CORAL:rosa|SALMON:rosa|DURAZNO:rosa|LILA:rosa|NARANJA:naranja|ORANGE:naranja|CAMO:camo|CAMUFLADO:camo|CAMUFLAJE:camo'.split('|').map(function (e) { var kv = e.split(':'); return [kv[0], kv[1]]; });
  var MAT = {}; ',amarillo-amarillo:-20,amarillo-azul:4,amarillo-beige:6,amarillo-blanco:12,amarillo-bordo:-10,amarillo-camo:-25,amarillo-crema:8,amarillo-denim:18,amarillo-gris:12,amarillo-marino:15,amarillo-marron:6,amarillo-mostaza:-25,amarillo-naranja:-25,amarillo-negro:15,amarillo-rojo:-20,amarillo-rosa:-20,amarillo-verde:-20,azul-azul:-20,azul-beige:18,azul-blanco:18,azul-bordo:-10,azul-camo:-25,azul-celeste:-2,azul-crema:18,azul-denim:6,azul-gris:15,azul-marino:5,azul-marron:15,azul-mostaza:8,azul-negro:10,azul-rojo:-10,azul-rosa:4,azul-verde:-10,beige-beige:8,beige-blanco:16,beige-bordo:18,beige-camo:15,beige-celeste:18,beige-crema:12,beige-denim:18,beige-gris:10,beige-marino:18,beige-marron:16,beige-mostaza:10,beige-naranja:6,beige-negro:18,beige-rojo:8,beige-rosa:12,beige-verde:18,blanco-blanco:4,blanco-bordo:12,blanco-camo:18,blanco-celeste:15,blanco-crema:8,blanco-denim:20,blanco-gris:15,blanco-marino:20,blanco-marron:15,blanco-mostaza:12,blanco-naranja:12,blanco-negro:20,blanco-rojo:15,blanco-rosa:15,blanco-verde:15,bordo-bordo:-20,bordo-camo:-25,bordo-celeste:-10,bordo-crema:18,bordo-denim:16,bordo-gris:14,bordo-marino:10,bordo-marron:12,bordo-mostaza:-2,bordo-naranja:-20,bordo-negro:15,bordo-rojo:-25,bordo-rosa:-20,bordo-verde:-5,camo-camo:-40,camo-celeste:-25,camo-crema:18,camo-denim:5,camo-gris:15,camo-marino:8,camo-marron:12,camo-mostaza:-25,camo-naranja:-25,camo-negro:20,camo-rojo:-25,camo-rosa:-25,camo-verde:-5,celeste-celeste:-20,celeste-crema:15,celeste-denim:8,celeste-gris:12,celeste-marino:18,celeste-marron:15,celeste-mostaza:-10,celeste-naranja:-10,celeste-negro:10,celeste-rojo:-10,celeste-verde:-10,crema-crema:6,crema-denim:20,crema-gris:14,crema-marino:20,crema-marron:20,crema-mostaza:15,crema-naranja:10,crema-negro:18,crema-rojo:12,crema-rosa:15,crema-verde:20,denim-denim:-6,denim-gris:15,denim-marino:8,denim-marron:16,denim-mostaza:20,denim-naranja:15,denim-negro:18,denim-rojo:18,denim-rosa:18,denim-verde:15,gris-gris:2,gris-marino:14,gris-marron:8,gris-mostaza:10,gris-naranja:10,gris-negro:16,gris-rojo:12,gris-rosa:12,gris-verde:8,marino-marino:2,marino-marron:12,marino-mostaza:18,marino-naranja:15,marino-negro:6,marino-rojo:12,marino-rosa:15,marino-verde:8,marron-marron:6,marron-mostaza:16,marron-naranja:6,marron-negro:8,marron-rojo:4,marron-rosa:8,marron-verde:16,mostaza-mostaza:-20,mostaza-naranja:-20,mostaza-negro:18,mostaza-rojo:-25,mostaza-rosa:-25,mostaza-verde:5,naranja-naranja:-20,naranja-negro:15,naranja-rojo:-30,naranja-rosa:-10,naranja-verde:-20,negro-negro:10,negro-rojo:18,negro-rosa:8,negro-verde:15,rojo-rojo:-20,rojo-rosa:-30,rojo-verde:-35,rosa-rosa:-20,rosa-verde:-15,verde-verde:-20,'.split(',').forEach(function (e) { if (!e) return; var kv = e.split(':'); MAT[kv[0]] = parseInt(kv[1], 10); });
  var STY = {}; ',basic-basic:8,basic-smart:10,basic-sport:6,basic-street:8,smart-smart:18,smart-sport:-18,smart-street:-12,sport-sport:16,sport-street:6,street-street:18,'.split(',').forEach(function (e) { if (!e) return; var kv = e.split(':'); STY[kv[0]] = parseInt(kv[1], 10); });
  var NEUTROS = ['negro', 'blanco', 'crema', 'beige', 'marron', 'gris', 'marino', 'denim'];
  var NO_DENIM = ['JOGGER', 'JOGGIN', 'MOLETON', 'LINO', 'CHINO', 'DIAMOND', 'SATORI', 'BOXER'];
  var ESTILOS = [
    ['sport', ['CAMISILLA', 'MUSCULOSA', 'BASKEBALL', 'BASKETBALL', 'JERSEY', 'JOGGER', 'JOGGIN', 'JOGGING', 'MOLETON', 'DEPORTIVO', 'SPORT']],
    ['smart', ['POLO', 'POLOS', 'CAMISA', 'LINO', 'OXFORD', 'CHINO', 'MAO', 'SASTRERO', 'VESTIR']],
    ['street', ['OVERSIZE', 'BOXY', 'HEAVY', 'BABY TEE', 'LMRDM', 'LMRM', 'BAGGY', 'WIDE', 'JORT', 'JORTS', 'CARPENTER', 'CARGO', 'GIANT', 'POCKET', 'CAMO', 'CANGURO', 'HOODIE']]
  ];
  var FLAGS = [
    ['abrigo', ['CANGURO', 'HOODIE', 'SWEATER', 'CAMPERA', 'JACKET', 'BOMBER', 'BUZO']],
    ['corto', ['SHORT', 'SHORTS', 'SHORS', 'BERMUDA', 'BERMUDAS', 'BERM', 'JORT', 'JORTS']],
    ['lino', ['LINO']],
    ['marca', ['REDENTOR', 'RDTR', 'RNDTR']],
    ['liso', ['BASIC', 'BASICO', 'LISO', 'PREMIUM']],
    ['polo', ['POLO', 'POLOS']],
    ['jean', ['JEANS', 'JEAN', 'DENIM', 'JORT', 'JORTS']]
  ];

  function tiene(u, lista) { for (var i = 0; i < lista.length; i++) if (u.indexOf(' ' + lista[i] + ' ') >= 0) return true; return false; }

  function rasgos(titulo, parte) {
    var u = (' ' + String(titulo).toUpperCase().replace(/[\/\-.,()]/g, ' ') + ' ').replace(/ {2,}/g, ' ');
    u = u.split(' SANTA MONICA POLO ').join(' SMP ');
    var hall = [];
    DIC.forEach(function (kv) {
      var k = ' ' + kv[0] + ' ', p = u.indexOf(k);
      if (p >= 0) {
        hall.push([p, kv[1]]);
        if (kv[0].indexOf(' ') >= 0) u = u.split(k).join(' ' + kv[0].replace(/ /g, '_') + ' ');
      }
    });
    hall.sort(function (a, b) { return a[0] - b[0] || (a[1] < b[1] ? -1 : a[1] > b[1] ? 1 : 0); });
    var main = 'x', sec = 'x';
    for (var i = 0; i < hall.length; i++) {
      if (main === 'x') main = hall[i][1];
      else if (hall[i][1] !== main) { sec = hall[i][1]; break; }
    }
    if (parte === 'inferior' && (main === 'azul' || main === 'celeste' || main === 'marino') && !tiene(u, NO_DENIM)) main = 'denim';
    var est = 'basic';
    for (var j = 0; j < ESTILOS.length; j++) if (tiene(u, ESTILOS[j][1])) { est = ESTILOS[j][0]; break; }
    var fl = {};
    FLAGS.forEach(function (f) { if (tiene(u, f[1])) fl[f[0]] = true; });
    if (parte === 'superior' && est !== 'smart' && fl.marca && !fl.liso) fl.grafica = true;
    if (parte === 'inferior') fl.inf = true;
    return { m: main, s: sec, e: est, f: fl };
  }

  function par(a, b) { var k = [a, b].sort().join('-'); return MAT.hasOwnProperty(k) ? MAT[k] : 0; }

  function puntos(A, B) {
    var sc;
    if (A.m === 'x') sc = NEUTROS.indexOf(B.m) >= 0 ? 8 : -2;
    else if (B.m === 'x') sc = -4;
    else sc = par(A.m, B.m);
    [[A.s, B.m], [A.m, B.s]].forEach(function (pp) {
      if (pp[0] === 'x' || pp[1] === 'x') return;
      var v = par(pp[0], pp[1]);
      if (v <= -15) sc += Math.floor(v / 2);
    });
    if (A.s !== 'x' && A.s === B.m) sc += 6;
    if (B.s !== 'x' && B.s === A.m) sc += 6;
    var k = [A.e, B.e].sort().join('-');
    if (STY.hasOwnProperty(k)) sc += STY[k];
    var abr = A.f.abrigo || B.f.abrigo, cor = A.f.corto || B.f.corto;
    if (abr && cor) sc -= 12;
    if (A.f.lino && B.f.lino) sc += 10;
    if ((A.f.grafica || B.f.grafica) && (A.m === 'camo' || B.m === 'camo')) sc -= 20;
    if ((A.e === 'sport' || B.e === 'sport') && A.e !== B.e && !cor) sc -= 8;
    /* Polo: solo con chinos, pantalones de lino o shorts que no sean de jean (nunca con jeans ni jorts) */
    var P = A.f.polo ? A : (B.f.polo ? B : null), O = P === A ? B : A;
    if (P && O.f.inf && !(O.e === 'smart' || (O.f.corto && !O.f.jean && O.m !== 'denim'))) sc -= 80;
    return sc;
  }

  var LETRAS = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', '4XL', '5XL', '6XL'];
  function ordenTalle(v) {
    var t = String(v).toUpperCase().trim(), i = LETRAS.indexOf(t);
    if (i >= 0) return i + 1;
    if (t === '2XL') return 7;
    if (t === '3XL') return 8;
    var n = parseFloat(t);
    return n > 0 ? 100 + n : 999;
  }

  function dinero(cents, formato) {
    var n = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (formato || 'Gs. {{amount}}').replace(/\{\{\s*[a-z_]+\s*\}\}/, n).replace(/<[^>]*>/g, '');
  }

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function miniatura(u, w) {
    if (!u) return '';
    return /[?&]width=\d+/.test(u) ? u.replace(/([?&]width=)\d+/, '$1' + w) : u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
  }

  function lista(s) { return String(s || '').split('+').map(function (x) { return x.trim(); }).filter(Boolean); }

  var ICO_SWAP = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 5.5h10l-2.5-2.5"/><path d="M13 10.5H3l2.5 2.5"/></svg>';
  var ICO_X = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M4 4l8 8M12 4l-8 8"/></svg>';
  var ICO_PREV = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 3L5 8l5 5"/></svg>';
  var ICO_NEXT = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 3l5 5-5 5"/></svg>';

  /* Carga una colección completa (todas las páginas) desde la plantilla collection.ms-look-datos.
     Máximo 3 pedidos a la vez, reintenta si Shopify responde 429/5xx y guarda 15 min en la sesión. */
  var cacheCol = {}, cola = [], activos = 0, TTL = 15 * 60 * 1000, PREF = 'msLook:v2:';
  function turno(fn) {
    return new Promise(function (ok, mal) {
      cola.push(function () {
        activos++;
        fn().then(ok, mal).then(function () { activos--; if (cola.length) cola.shift()(); });
      });
      if (activos < 3) cola.shift()();
    });
  }
  function esperar(ms) { return new Promise(function (ok) { setTimeout(ok, ms); }); }
  function leerCache(h) {
    try { var c = JSON.parse(sessionStorage.getItem(PREF + h)); if (c && Date.now() - c.t < TTL && c.p) return c.p; } catch (e) {}
    return null;
  }
  function guardarCache(h, p) { try { sessionStorage.setItem(PREF + h, JSON.stringify({ t: Date.now(), p: p })); } catch (e) {} }
  function cargarColeccion(base, vista, h) {
    if (cacheCol[h]) return cacheCol[h];
    var guardado = leerCache(h);
    if (guardado) return (cacheCol[h] = Promise.resolve(JSON.parse(JSON.stringify(guardado))));
    var fallo = false;
    function pagina(n, intento) {
      intento = intento || 1;
      return turno(function () {
        return fetch(base + '/collections/' + encodeURIComponent(h) + '?view=' + vista + '&page=' + n, { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text().then(function (t) { return { ok: true, t: t }; }) : { ok: false, s: r.status }; });
      }).catch(function () { return { ok: false, s: 0 }; }).then(function (res) {
        if (res.ok) { try { return JSON.parse(res.t); } catch (e) { fallo = true; return { pages: 1, p: [] }; } }
        if (intento < 3 && (res.s === 429 || res.s === 0 || res.s >= 500)) return esperar(700 * intento * intento).then(function () { return pagina(n, intento + 1); });
        fallo = true;
        return { pages: 1, p: [] };
      });
    }
    cacheCol[h] = pagina(1).then(function (d) {
      var total = Math.min(Number(d.pages) || 1, 10), resto = [];
      for (var n = 2; n <= total; n++) resto.push(pagina(n));
      return Promise.all(resto).then(function (otras) {
        var todo = otras.reduce(function (acc, o) { return acc.concat(o.p || []); }, d.p || []);
        if (!fallo) guardarCache(h, todo);
        else delete cacheCol[h];
        return todo;
      });
    });
    return cacheCol[h];
  }

  function MsLook(root) {
    var cfg;
    try { cfg = JSON.parse(root.querySelector('script[data-ms-look]').textContent); } catch (e) { return; }
    var stage = root.querySelector('[data-ms-look-stage]');
    var base = String(cfg.root || '/').replace(/\/$/, '');
    var vista = cfg.view || 'ms-look-datos';
    var fuentes = { top: lista(cfg.sup), bot: lista(cfg.inf), ext: lista(cfg.ext) };
    var excluir = lista(cfg.excl);
    var filtros = cfg.filtros || [];
    var maxExtras = typeof cfg.maxx === 'number' ? cfg.maxx : 3;
    var umbral = typeof cfg.umbral === 'number' ? cfg.umbral : 10;
    var pct = Number(cfg.desc) || 0;
    var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var porH = {}, allTops = [], allBots = [], allExt = [], tops = [], bots = [];
    var estado = { top: null, bot: null, ext: [] }, sel = {};
    var picker = null, extListo = null, iniciado = false;
    var vistos = {}, recTops = [], recBots = [];

    function preparar(p, grupo) {
      if (!p || !p.h || porH[p.h] || !p.v || !p.v.length) return null;
      var k = p.k || [];
      for (var i = 0; i < excluir.length; i++) if (k.indexOf(excluir[i]) >= 0) return null;
      p.d = p.v.filter(function (v) { return v[2]; }).length;
      if (!p.d) return null;
      p.v.sort(function (a, b) { return ordenTalle(a[1]) - ordenTalle(b[1]); });
      p.g = grupo;
      p.r = rasgos(p.t, grupo === 'bot' ? 'inferior' : 'superior');
      p.u = base + '/products/' + p.h;
      p.pf = dinero(p.p, cfg.fmt);
      porH[p.h] = p;
      return p;
    }

    function cargarGrupo(hs) { return Promise.all(hs.map(function (h) { return cargarColeccion(base, vista, h); })); }

    function conTalles(l) { var f = l.filter(function (p) { return p.d >= 2 || p.v.length === 1; }); return f.length >= 6 ? f : l; }

    function candidatos(top) {
      var l = bots.map(function (b) { return { b: b, s: puntos(top.r, b.r) }; })
        .filter(function (x) { return x.s >= umbral; })
        .sort(function (a, b) { return b.s - a.s; });
      var frescos = l.filter(function (x) { return recBots.indexOf(x.b.h) < 0; });
      return (frescos.length >= 2 ? frescos : l).slice(0, 8);
    }

    function nuevoLook() {
      for (var intento = 0; intento < 60; intento++) {
        var top = tops[Math.floor(Math.random() * tops.length)];
        if (intento < 40 && recTops.indexOf(top.h) >= 0) continue;
        var cands = candidatos(top).filter(function (x) { return !vistos[top.h + '|' + x.b.h]; });
        if (!cands.length) continue;
        var peso = cands.map(function (x, i) { return Math.max(1, cands.length - i); });
        var total = peso.reduce(function (a, b) { return a + b; }, 0), r = Math.random() * total, k = 0;
        while (r > peso[k]) { r -= peso[k]; k++; }
        var bot = cands[k].b;
        vistos[top.h + '|' + bot.h] = true;
        [top, bot].forEach(function (x) { if (x.img && !x.pre) { x.pre = new Image(); x.pre.src = x.img; } });
        recTops.push(top.h); if (recTops.length > Math.min(8, tops.length - 1)) recTops.shift();
        recBots.push(bot.h); if (recBots.length > Math.min(3, bots.length - 2)) recBots.shift();
        return [top, bot];
      }
      vistos = {};
      return null;
    }

    function items() { return [estado.top, estado.bot].concat(estado.ext); }

    function autoTalle(p) { if (p.v.length === 1 && p.v[0][2]) sel[p.h] = p.v[0][0]; }

    function nombreTalle(t) { return /^default title$/i.test(t) ? 'Único' : t; }

    function talles(p) {
      return '<div class="ms-look__sizes" role="group" aria-label="Elegí tu talle de ' + esc(p.t) + '">' + p.v.map(function (v) {
        var on = String(sel[p.h]) === String(v[0]);
        return '<button type="button" class="ms-look__size' + (on ? ' is-on' : '') + '" data-h="' + esc(p.h) + '" data-v="' + v[0] + '" aria-pressed="' + on + '"' +
          (v[2] ? '' : ' disabled') + ' aria-label="Talle ' + esc(nombreTalle(v[1])) + '">' + esc(nombreTalle(v[1])) + '</button>';
      }).join('') + '</div>';
    }

    function tarjeta(p, slot) {
      return '<div class="ms-look__info" data-item="' + slot + '">' +
        '<div class="ms-look__line"><a class="ms-look__name" href="' + esc(p.u) + '">' + esc(p.t) + '</a><span class="ms-look__price">' + esc(p.pf) + '</span></div>' +
        talles(p) + '</div>';
    }

    function extra(p, i) {
      return '<div class="ms-look__info ms-look__info--x" data-item="x' + i + '">' +
        '<div class="ms-look__xrow">' +
          '<a class="ms-look__xthumb" href="' + esc(p.u) + '" tabindex="-1" aria-hidden="true">' + (p.img ? '<img src="' + esc(miniatura(p.img, 200)) + '" alt="" decoding="async">' : '') + '</a>' +
          '<div class="ms-look__line"><a class="ms-look__name" href="' + esc(p.u) + '">' + esc(p.t) + '</a><span class="ms-look__price">' + esc(p.pf) + '</span></div>' +
          '<button type="button" class="ms-look__xdel" data-del="' + i + '" aria-label="Quitar ' + esc(p.t) + ' del look">' + ICO_X + '</button>' +
        '</div>' + talles(p) + '</div>';
    }

    function foto(p, slot) {
      var que = slot === 'top' ? 'prenda de arriba' : 'prenda de abajo';
      return '<button type="button" class="ms-look__media" data-pick="' + slot + '" data-item="' + slot + '" aria-expanded="false" aria-label="Cambiar ' + que + ': ' + esc(p.t) + '">' +
        (p.img ? '<img src="' + esc(p.img) + '" alt="" decoding="async">' : '') +
        '<span class="ms-look__swap" aria-hidden="true">' + ICO_SWAP + 'Cambiar</span></button>';
    }

    function botonExtra() {
      return '<button type="button" class="ms-look__addx" data-pick="ext" aria-expanded="false">' +
        '<span class="ms-look__addx-ico" aria-hidden="true">+</span>' +
        '<span class="ms-look__addx-txt"><strong>Añadir otra prenda</strong>' +
        '<small>Opcional · calzado, otra remera, un abrigo…' + (pct > 0 ? ' también con −' + pct + '%' : '') + '</small></span></button>';
    }

    function pintar(nuevo) {
      var its = items(), total = its.reduce(function (s, p) { return s + p.p; }, 0);
      var final = pct > 0 ? Math.round(total * (100 - pct) / 100 / 100) * 100 : total;
      var ahorro = total - final;
      var promo = pct > 0 ? '<span class="ms-look__chip ms-look__chip--promo">−' + pct + '% llevando el look completo · ahorrás ' + dinero(ahorro, cfg.fmt) + '</span>' : '';
      var envio = cfg.envio > 0 ? (final >= cfg.envio
        ? '<span class="ms-look__chip">✓ Envío gratis incluido</span>'
        : '<span class="ms-look__chip ms-look__chip--off">Te faltan ' + dinero(cfg.envio - final, cfg.fmt) + ' para el envío gratis</span>') : '';
      var cuantas = its.length === 2 ? 'Llevando los dos' : 'Look de ' + its.length + ' prendas';
      picker = null;
      stage.innerHTML =
        '<div class="ms-look__left">' +
          '<div class="ms-look__pics">' + foto(estado.top, 'top') + '<span class="ms-look__plus" aria-hidden="true">+</span>' + foto(estado.bot, 'bot') + '</div>' +
          '<div class="ms-look__slot" data-slot="main"></div>' +
        '</div>' +
        '<div class="ms-look__right">' +
          tarjeta(estado.top, 'top') + tarjeta(estado.bot, 'bot') +
          estado.ext.map(extra).join('') +
          (estado.ext.length < maxExtras ? botonExtra() : '') +
          '<div class="ms-look__slot" data-slot="ext"></div>' +
          (promo || envio ? '<div class="ms-look__chips">' + promo + envio + '</div>' : '') +
          '<div class="ms-look__foot"><div class="ms-look__total"><strong>' + dinero(final, cfg.fmt) +
          (pct > 0 ? ' <s>' + dinero(total, cfg.fmt) + '</s>' : '') + '</strong>' +
          (pct > 0 && ahorro > 0 ? '<em class="ms-look__ahorro">Ahorrás ' + dinero(ahorro, cfg.fmt) + '</em>' : '') +
          '<span>' + cuantas + (pct > 0 ? ' · ' + pct + '% OFF' : '') + '</span></div>' +
          '<button type="button" class="ms-look__add" data-ms-look-add disabled>Elegí los talles</button>' +
          '<p class="ms-look__msg" role="status" aria-live="polite"></p></div>' +
        '</div>';
      stage.classList.add('is-ready');
      actualizarBoton();
      if (nuevo === true) { stage.classList.remove('is-in'); void stage.offsetWidth; stage.classList.add('is-in'); }
      else if (nuevo) stage.querySelectorAll('[data-item="' + nuevo + '"]').forEach(function (el) { el.classList.add('is-new'); });
    }

    function actualizarBoton() {
      var btn = stage.querySelector('[data-ms-look-add]');
      if (!btn || btn.classList.contains('is-loading')) return;
      var its = items(), faltan = its.filter(function (p) { return !sel[p.h]; }).length;
      btn.disabled = faltan > 0;
      btn.textContent = !faltan ? (cfg.agregar || 'Agregar el look al carrito')
        : faltan === its.length ? 'Elegí los talles'
        : 'Falta elegir ' + faltan + (faltan === 1 ? ' talle' : ' talles');
    }

    /* ---------- Lista para elegir a mano ---------- */
    function armonia(p) {
      var m = p.r.m, a = estado.top.r.m, b = estado.bot.r.m;
      if (m === 'x') return 4;
      return (a !== 'x' ? par(m, a) : 0) + (b !== 'x' ? par(m, b) : 0) + (NEUTROS.indexOf(m) >= 0 ? 6 : 0);
    }

    function opciones(modo) {
      var enLook = {}; items().forEach(function (p) { enLook[p.h] = true; });
      var arr = [], actual = modo === 'top' ? estado.top : modo === 'bot' ? estado.bot : null;
      if (modo === 'top') allTops.forEach(function (p) { arr.push({ p: p, s: puntos(p.r, estado.bot.r), x: 0 }); });
      else if (modo === 'bot') allBots.forEach(function (p) { arr.push({ p: p, s: puntos(estado.top.r, p.r), x: 0 }); });
      else {
        allExt.forEach(function (p) { arr.push({ p: p, s: armonia(p), x: 0 }); });
        allTops.forEach(function (p) { arr.push({ p: p, s: puntos(p.r, estado.bot.r), x: 1 }); });
        allBots.forEach(function (p) { arr.push({ p: p, s: puntos(estado.top.r, p.r), x: 2 }); });
      }
      arr = arr.filter(function (o) { return o.p === actual || !enLook[o.p.h]; });
      arr.forEach(function (o, i) { o.i = i; });
      arr.sort(function (a, b) {
        if (a.p === actual) return -1;
        if (b.p === actual) return 1;
        return a.x - b.x || b.s - a.s || a.i - b.i;
      });
      var estrellas = 0;
      arr.forEach(function (o) {
        o.cur = o.p === actual;
        o.star = false;
        if (!o.cur && modo !== 'ext' && o.s >= umbral && estrellas < 8) { o.star = true; estrellas++; }
      });
      return arr;
    }

    function chipsDe(arr, modo) {
      var cs = [];
      filtros.forEach(function (f, orden) {
        var n = 0, nx = 0;
        arr.forEach(function (o) { if (o.p.k && o.p.k.indexOf(f.h) >= 0) { n++; if (o.x === 0) nx++; } });
        if (n) cs.push({ h: f.h, t: f.t, n: n, prio: modo === 'ext' && nx * 2 >= n ? 0 : 1, orden: orden });
      });
      cs.sort(function (a, b) { return a.prio - b.prio || a.orden - b.orden; });
      return [{ h: '*', t: 'Todas', n: arr.length }].concat(cs);
    }

    function llenarPicker() {
      if (!picker) return;
      var panel = stage.querySelector('.ms-look__pk');
      if (!panel) return;
      var arr = opciones(picker.modo), cs = chipsDe(arr, picker.modo);
      if (!cs.some(function (c) { return c.h === picker.filtro; })) picker.filtro = '*';
      var vis = picker.filtro === '*' ? arr : arr.filter(function (o) { return o.p.k && o.p.k.indexOf(picker.filtro) >= 0; });
      panel.querySelector('.ms-look__pk-filters').innerHTML = cs.length > 2 || picker.modo === 'ext' ? cs.map(function (c) {
        var on = c.h === picker.filtro;
        return '<button type="button" class="ms-look__pk-chip' + (on ? ' is-on' : '') + '" data-pk-filtro="' + esc(c.h) + '" aria-pressed="' + on + '">' + esc(c.t) + ' <span>' + c.n + '</span></button>';
      }).join('') : '';
      var rail = panel.querySelector('.ms-look__pk-rail');
      rail.innerHTML = vis.length ? vis.map(function (o) {
        var p = o.p;
        return '<li><button type="button" class="ms-look__opt' + (o.cur ? ' is-cur' : '') + '" data-elegir="' + esc(p.h) + '"' + (o.cur ? ' aria-current="true"' : '') + '>' +
          '<span class="ms-look__opt-img">' + (p.img ? '<img src="' + esc(miniatura(p.img, 360)) + '" alt="" loading="lazy" decoding="async">' : '') +
          (o.cur ? '<span class="ms-look__badge ms-look__badge--cur">Elegida</span>' : o.star ? '<span class="ms-look__badge">★ Combina</span>' : '') + '</span>' +
          '<span class="ms-look__opt-name">' + esc(p.t) + '</span><span class="ms-look__opt-price">' + esc(p.pf) + '</span></button></li>';
      }).join('') : '<li class="ms-look__pk-empty">No hay prendas disponibles en esta categoría.</li>';
      rail.scrollLeft = 0;
      flechas();
    }

    function flechas() {
      var panel = stage.querySelector('.ms-look__pk');
      if (!panel) return;
      var rail = panel.querySelector('.ms-look__pk-rail'), max = rail.scrollWidth - rail.clientWidth - 2;
      panel.querySelector('[data-pk-scroll="-1"]').disabled = rail.scrollLeft <= 2;
      panel.querySelector('[data-pk-scroll="1"]').disabled = rail.scrollLeft >= max;
    }

    function abrirPicker(modo, trigger) {
      if (picker && picker.modo === modo) { cerrarPicker(); return; }
      cerrarPicker(true);
      var slot = stage.querySelector('[data-slot="' + (modo === 'ext' ? 'ext' : 'main') + '"]');
      if (!slot) return;
      picker = { modo: modo, filtro: '*', trigger: trigger };
      var titulo = modo === 'top' ? 'Elegí la prenda de arriba' : modo === 'bot' ? 'Elegí la prenda de abajo' : 'Añadí otra prenda';
      var pista = modo === 'top' ? '★ Combina muy bien con la prenda de abajo' : modo === 'bot' ? '★ Combina muy bien con la prenda de arriba' : 'Tocá una prenda para sumarla al look';
      slot.innerHTML = '<div class="ms-look__pk" role="region" aria-label="' + titulo + '">' +
        '<div class="ms-look__pk-head"><p class="ms-look__pk-title" tabindex="-1">' + titulo + '</p>' +
        '<button type="button" class="ms-look__pk-x" data-pk-close aria-label="Cerrar">' + ICO_X + '</button></div>' +
        '<div class="ms-look__pk-filters" role="group" aria-label="Filtrar por tipo"></div>' +
        '<p class="ms-look__pk-hint">' + pista + '</p>' +
        '<div class="ms-look__pk-railwrap">' +
          '<button type="button" class="ms-look__pk-arrow ms-look__pk-arrow--prev" data-pk-scroll="-1" aria-label="Ver anteriores" disabled>' + ICO_PREV + '</button>' +
          '<ul class="ms-look__pk-rail" role="list"><li class="ms-look__pk-empty">Cargando prendas…</li></ul>' +
          '<button type="button" class="ms-look__pk-arrow ms-look__pk-arrow--next" data-pk-scroll="1" aria-label="Ver más">' + ICO_NEXT + '</button>' +
        '</div></div>';
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      slot.querySelector('.ms-look__pk-rail').addEventListener('scroll', flechas, { passive: true });
      if (modo === 'ext') cargarExtras().then(function () { if (picker && picker.modo === 'ext') llenarPicker(); });
      else llenarPicker();
      var t = slot.querySelector('.ms-look__pk-title');
      t.focus({ preventScroll: true });
      var caja = slot.getBoundingClientRect();
      if (caja.top < 70 || caja.bottom > window.innerHeight) slot.scrollIntoView({ block: caja.height > window.innerHeight - 90 ? 'start' : 'nearest', behavior: reducido ? 'auto' : 'smooth' });
    }

    function cerrarPicker(silencio) {
      var t = picker && picker.trigger;
      stage.querySelectorAll('[data-slot]').forEach(function (s) { s.innerHTML = ''; });
      stage.querySelectorAll('[data-pick][aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      picker = null;
      if (!silencio && t && document.body.contains(t)) t.focus({ preventScroll: true });
    }

    function elegir(h) {
      var p = porH[h];
      if (!p || !picker) return;
      var modo = picker.modo, marca;
      if (modo === 'top') { estado.top = p; marca = 'top'; }
      else if (modo === 'bot') { estado.bot = p; marca = 'bot'; }
      else if (estado.ext.length < maxExtras) { estado.ext.push(p); marca = 'x' + (estado.ext.length - 1); }
      estado.ext = estado.ext.filter(function (x) { return x !== estado.top && x !== estado.bot; });
      autoTalle(p);
      pintar(marca);
      var foco = modo === 'ext'
        ? stage.querySelector('[data-item="' + marca + '"] .ms-look__size:not([disabled])')
        : stage.querySelector('.ms-look__media[data-pick="' + modo + '"]');
      if (foco) foco.focus({ preventScroll: true });
      if (modo !== 'ext') {
        var pics = stage.querySelector('.ms-look__pics'), c = pics.getBoundingClientRect();
        if (c.top < 60 || c.top > window.innerHeight * 0.6) pics.scrollIntoView({ block: 'start', behavior: reducido ? 'auto' : 'smooth' });
      }
    }

    function cargarExtras() {
      if (!extListo) {
        extListo = cargarGrupo(fuentes.ext).then(function (res) {
          res.forEach(function (l) { l.forEach(function (p) { if (preparar(p, 'ext')) allExt.push(p); }); });
        }).catch(function () {});
      }
      return extListo;
    }

    /* ---------- Carrito ---------- */
    function conDescuento() {
      // El código se aplica antes de sumar las prendas: Shopify lo guarda y lo activa cuando el look está en el carrito
      if (!(pct > 0) || !cfg.codigo) return Promise.resolve();
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: cfg.codigo }) })
        .catch(function () {});
    }

    function agregar(btn) {
      var lines = items().map(function (p) { return sel[p.h]; });
      var msg = stage.querySelector('.ms-look__msg');
      msg.textContent = '';
      btn.disabled = true; btn.classList.add('is-loading');
      var actions = window.Shopify && window.Shopify.actions;
      var hecho = function () {
        btn.classList.remove('is-loading'); btn.textContent = '✓ Look agregado';
        setTimeout(actualizarBoton, 2500);
      };
      var fallo = function () { btn.classList.remove('is-loading'); btn.disabled = false; actualizarBoton(); msg.textContent = 'No se pudo agregar. Probá de nuevo.'; };
      conDescuento().then(function () {
        if (actions && actions.updateCart) {
          return actions.updateCart({ lines: lines.map(function (id) { return { merchandiseId: String(id), quantity: 1 }; }) }, { event: { context: 'standard-action' } })
            .then(function (res) {
              if (res && res.userErrors && res.userErrors.length) throw new Error(res.userErrors[0].message);
              hecho(); if (actions.openCart) actions.openCart();
            });
        }
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: lines.map(function (id) { return { id: Number(id), quantity: 1 }; }) }) })
          .then(function (r) { if (!r.ok) throw new Error('x'); window.location.href = '/cart'; });
      }).catch(fallo);
    }

    /* ---------- Eventos ---------- */
    root.addEventListener('click', function (e) {
      var el;
      if ((el = e.target.closest('.ms-look__size'))) {
        if (el.disabled) return;
        var h = el.dataset.h;
        sel[h] = el.dataset.v;
        stage.querySelectorAll('.ms-look__size').forEach(function (x) {
          if (x.dataset.h !== h) return;
          var on = x === el; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', String(on));
        });
        actualizarBoton();
        return;
      }
      if ((el = e.target.closest('[data-elegir]'))) { elegir(el.dataset.elegir); return; }
      if ((el = e.target.closest('[data-pk-filtro]'))) {
        if (!picker) return;
        picker.filtro = el.dataset.pkFiltro;
        var cual = picker.filtro;
        llenarPicker();
        var ch = stage.querySelector('[data-pk-filtro="' + cual.replace(/"/g, '') + '"]');
        if (ch) ch.focus({ preventScroll: true });
        return;
      }
      if ((el = e.target.closest('[data-pk-scroll]'))) {
        var rail = stage.querySelector('.ms-look__pk-rail');
        if (rail) rail.scrollBy({ left: Number(el.dataset.pkScroll) * rail.clientWidth * 0.85, behavior: reducido ? 'auto' : 'smooth' });
        return;
      }
      if (e.target.closest('[data-pk-close]')) { cerrarPicker(); return; }
      if ((el = e.target.closest('[data-pick]'))) { abrirPicker(el.dataset.pick, el); return; }
      if ((el = e.target.closest('[data-del]'))) {
        estado.ext.splice(Number(el.dataset.del), 1);
        pintar();
        var bx = stage.querySelector('.ms-look__addx');
        if (bx) bx.focus({ preventScroll: true });
        return;
      }
      if (e.target.closest('[data-ms-look-next]')) {
        if (!iniciado || !tops.length) return;
        var n = nuevoLook();
        if (n) {
          estado.top = n[0]; estado.bot = n[1];
          estado.ext = estado.ext.filter(function (x) { return x !== estado.top && x !== estado.bot; });
          autoTalle(n[0]); autoTalle(n[1]);
          pintar(true);
        }
        return;
      }
      if ((el = e.target.closest('[data-ms-look-add]')) && !el.disabled) agregar(el);
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && picker) { e.preventDefault(); cerrarPicker(); }
    });

    function iniciar() {
      if (iniciado) return;
      iniciado = true;
      Promise.all([cargarGrupo(fuentes.top), cargarGrupo(fuentes.bot)]).then(function (res) {
        res[0].forEach(function (l) { l.forEach(function (p) { if (preparar(p, 'top')) allTops.push(p); }); });
        res[1].forEach(function (l) { l.forEach(function (p) { if (preparar(p, 'bot')) allBots.push(p); }); });
        tops = conTalles(allTops); bots = conTalles(allBots);
        if (!tops.length || !bots.length) { root.hidden = true; return; }
        var n = nuevoLook();
        if (!n) { root.hidden = true; return; }
        estado.top = n[0]; estado.bot = n[1];
        autoTalle(n[0]); autoTalle(n[1]);
        pintar(true);
        // Las prendas extra se cargan recién cuando el cliente llega a la sección
        if (maxExtras > 0) {
          if ('IntersectionObserver' in window) {
            var ioX = new IntersectionObserver(function (en) {
              if (en.some(function (x) { return x.isIntersecting; })) { ioX.disconnect(); setTimeout(cargarExtras, 600); }
            }, { rootMargin: '150px 0px' });
            ioX.observe(root);
          } else setTimeout(cargarExtras, 2000);
        }
      }).catch(function () { root.hidden = true; });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        if (en.some(function (x) { return x.isIntersecting; })) { io.disconnect(); iniciar(); }
      }, { rootMargin: '900px 0px' });
      io.observe(root);
      // Se adelanta la carga cuando la página terminó de cargar, para que el look ya esté listo al bajar
      var temprano = function () {
        var ya = function () { io.disconnect(); iniciar(); };
        if (window.requestIdleCallback) requestIdleCallback(ya, { timeout: 2500 }); else setTimeout(ya, 600);
      };
      if (document.readyState === 'complete') temprano(); else window.addEventListener('load', temprano, { once: true });
    } else iniciar();
  }

  function init() { document.querySelectorAll('[data-ms-look-root]').forEach(function (r) { if (!r.__msLook) { r.__msLook = true; MsLook(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  window.__msLookTest = { rasgos: rasgos, puntos: puntos, ordenTalle: ordenTalle, dinero: dinero, miniatura: miniatura };
})();
